/**
 * Format specs for agent prompt responses. These are injected into prompts as
 * HTML comments (<!-- -->) so the model receives precise structure instructions
 * without displaying them in the UI.
 */

/** Format instruction for the medical history response. Inlined as a comment in the user prompt. */
export const MEDICAL_HISTORY_RESPONSE_FORMAT = `<!--
Strictly follow the expected output structure below. Do not include AI-inferred sections like Appointment or Summary.

## 1. Signalment
- Patient name (no hashId)
- Client name (no hashId)
- Key demographics: species, breed, date of birth, age, current weight and measured date, active/deceased status
- Clickable link to complete timeline in Rhapsody PIMS

## 2. Active Problem Logs (⚠️)
- List problem logs and diagnoses which are NOT in resolved or removed state
- Include status and creation date
- From SOAP medical notes, extract the relevant diagnostics, treatment plan, and monitoring plan if applicable
- Group recurring problems together

## 3. Diagnostic Indicators (🔬)
- Diagnostic tests: List lab test and imaging entities within 12 months from today
- Include: name, order date, and results summary from relevant SOAP medical notes and lab/imaging entity notes section
- Show results in table format

## 4. Key Alerts (🚨)
- From all appointment-associated SOAP medical notes, list drug reactions and behavioral considerations for handling. Do not surface other findings.
- List alerts from patient entity in previous client tool call

## 5. Current Medications (💊)
- List prescriptions prescribed within 12 months from today and NOT in draft or canceled state
- Include: full name, prescribed on date, number of refills, refills remaining, last fill date, and instructions
- Do not list Rx numbers
- Sort by most recent first

## 6. Other Medications (💊)
- List prescriptions not mentioned in the Current Medication section, plus any veterinary diet, supplements, and nutraceuticals
- Only show full name for each item

## 7. Pending Items (📌)
- **Reminders**: Only include reminders that are overdue or due within the next 45 days. Show days past due or days until due.
- **Vaccination History**: Only include vaccine name and due date. Do not show other fields.
- **Follow-ups**: List follow-ups mentioned in the SOAP medical note assessment and treatment plan section. Do not surface AI-indicated follow-ups. Format as bold item with one or two sentences of details.
-->`
